import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { environment } from 'src/environments/environment'; // <-- 1. Importar environment

/**
 * Interceptor de autenticación funcional para Angular 17+
 * Maneja automáticamente la adición del token de autorización y los errores 401
 */
export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router = inject(Router);

  // 2. CORRECCIÓN: Definimos la URL base de NetPay
  const netpayApiUrl = environment.netpay.apiUrl;

  // 3. CONDICIÓN DE EXCLUSIÓN: Si la URL incluye la URL base de NetPay, la ignoramos.
  if (request.url.includes(netpayApiUrl)) {
    // Si la URL es de NetPay, la dejamos pasar sin añadir el token Bearer de la aplicación.
    return next(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Mantenemos la gestión de errores 401 si se diera el caso en alguna otra parte de NetPay
        if (error.status === 401) {
          handleAuthError(router);
        }
        return throwError(() => error);
      }),
    );
  }

  // 👇 Lógica que SOLO se ejecuta en peticiones que NO son de NetPay 👇

  // Obtener token del localStorage
  const token = localStorage.getItem('access_token');

  // Si hay token, añadirlo a los headers
  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  // Continuar con la petición
  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // Si el error es 401 (No autorizado)
      if (error.status === 401) {
        handleAuthError(router);
      }

      return throwError(() => error);
    }),
  );
};

/**
 * Maneja el error de autenticación, limpiando el almacenamiento y redirigiendo al login
 */
function handleAuthError(router: Router): void {
  const auth = inject(AuthService);
  auth.signOut();
  localStorage.removeItem('access_token');
  localStorage.removeItem('currentUser');

  // Redirigir al login con mensaje
  router.navigate(['/login'], {
    queryParams: {
      expired: true,
      message: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
    },
  });
}
